if (!customElements.get('media-gallery-manuly')) {
    customElements.define(
        'media-gallery-manuly',
        class MediaGalleryManuly extends MediaGallery {
            constructor() {
                super();
                var opt1 = this.dataset.selectedVariantOption1;
                var opt2 = this.dataset.selectedVariantOption3 === '' ? this.dataset.selectedVariantOption2 : this.dataset.selectedVariantOption3;
                //this.showPictures(this, opt1, opt2);
            }

            connectedCallback() {
                var gallery = this;
                this.variantChangeCallback = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
                    var variant = event.data.variant;

                    var option3 = variant.option3;
                    if (option3 === null) {
                        option3 = variant.option2;
                    }
                   // gallery.showPictures(gallery, variant.option1, option3);
                });
            }

            showPictures(gallery, variantOption1, variantOption2) {
                var nodeListOf = gallery.querySelectorAll('li');
                for (let i = 0; i < nodeListOf.length; i++) {
                    const nodeListOfElement = nodeListOf[i];
                    var attributes = nodeListOfElement.getAttribute('data-thumbnail-id');
                    var attr = attributes.split("#");
                    var show = true;
                    for (let j = 0; j < attr.length && show; j++) {
                        const attrElement = attr[j];
                        var split = attrElement.split('_');
                        if (split[0] === 'size')
                        {
                            show = split[1].toLocaleLowerCase().trim() === variantOption1.toLocaleLowerCase().trim();
                            if(!show) break;
                        }

                        if (split[0] === 'color') {
                            {
                                show = split[1].toLocaleLowerCase().trim() === variantOption2.toLocaleLowerCase().trim();
                                if(!show) break;
                            }
                        }
                        if (split[0] === 'type') {
                            {
                                show = split[1].toLocaleLowerCase().trim() === variantOption1.toLocaleLowerCase().trim();
                                if(!show) break;
                            }
                        }
                        if (split[0] === 'hide'){
                            show = false;
                            break;
                        }
                    }

                    if (show) {
                        nodeListOfElement.classList.remove('hidden');
                    } else {
                        nodeListOfElement.classList.add('hidden');
                    }
                }
            }
        }
    );
}
